import { createSelector } from 'reselect';
import { selectInvestAccounts } from 'features/invest/reducers/selectors';
import { selectAllAccountsMap, selectIsGBUser, selectUser, } from 'reducers/selectors';
import { isEqual } from 'lodash';
import checkFeatureFlag from 'utils/featureFlags';
export const selectWealthBalanceInfo = createSelector([
    selectIsGBUser,
    selectInvestAccounts,
    (store) => store.pots.pots,
    (state) => state.pots.products,
], (isGBUser, investAccounts, pots, potProducts) => {
    if (isGBUser) {
        const data = [];
        let total = 0;
        const potsData = [];
        if (pots?.length) {
            const productIdNameMap = potProducts?.reduce((prev, curr) => ({
                ...prev,
                [curr.id]: curr.name,
            }), {});
            pots.forEach((pot) => {
                if (pot.balance.value) {
                    potsData.push({
                        pot,
                        id: pot.id,
                        potProductName: productIdNameMap?.[pot.productId],
                    });
                    total += pot.balance.value;
                }
            });
        }
        if (potsData.length) {
            potsData.sort((a, b) => b.pot.balance.value - a.pot.balance.value);
            const lastItem = potsData.pop();
            if (lastItem) {
                lastItem.isLastInSection = true;
                potsData.push(lastItem);
            }
            data.push({
                id: 'pots',
                sectionTitle: 'Money in your pots',
            });
            data.push({ ...potsData[0], isFirstInSection: true }, ...potsData.slice(1));
        }
        if (investAccounts?.length) {
            const activeInvestAccounts = investAccounts.filter((account) => account.account.broker !== 'alpaca' &&
                account.account.status === 'ACTIVE' &&
                (account.account.portfolioValue?.value ?? 0) > 0);
            if (activeInvestAccounts.length) {
                data.push({
                    id: 'investmentAccounts',
                    sectionTitle: 'Money in your investment accounts',
                });
                activeInvestAccounts.forEach((investAccount, index) => {
                    data.push({
                        id: investAccount.account.id,
                        investAccount,
                        ...(index === 0 && {
                            isFirstInSection: true,
                        }),
                    });
                    total += investAccount.account.portfolioValue?.value ?? 0;
                });
                const lastItem = data.pop();
                if (lastItem) {
                    lastItem.isLastInSection = true;
                    data.push(lastItem);
                }
            }
        }
        return {
            data,
            total,
        };
    }
    return undefined;
}, {
    memoizeOptions: {
        resultEqualityCheck: (a, b) => isEqual(a, b),
    },
});
export const selectConnectedBankAccount = createSelector([(state) => state.invest.connectedAccount, selectAllAccountsMap], (connectedAccount, allAccountsMap) => connectedAccount?.accountId != null
    ? allAccountsMap[connectedAccount.accountId]
    : undefined);
export const selectIsUserBlackListed = createSelector(selectUser, (user) => {
    if (user?.restrictionStatus) {
        return user.restrictionStatus === 'FULL_BLOCK';
    }
    return false;
});
export const selectHidePotNameScreen = createSelector([(store) => store.utils.featureFlags], (featureFlags) => checkFeatureFlag(featureFlags, 'remove_pot_name_screen_v2'));
export const selectIsaAllowance = (store) => store.wealth.isaAllowance;
